// axios.js
import axios from 'axios';
import { api } from '../urlConfig';
import store from '../store';
import {
    AUTH_SESSION_EXPIRED,
    SESSION_EXPIRED_MESSAGE,
    SESSION_EXPIRED_REASON,
    clearStoredAuthData,
    isAuthEntryRequest,
    isJwtExpiredError,
    saveSessionExpiredNotice,
} from './authSession';

const getToken = () => {
    const state = store.getState();

    return state?.auth?.token || window.localStorage.getItem('token') || '';
};

const axiosInstance = axios.create({
    baseURL: api,
});

let sessionExpirationHandled = false;

const redirectToSignin = () => {
    if (typeof window === 'undefined') return;

    const signinUrl = `/signin?reason=${SESSION_EXPIRED_REASON}`;

    if (window.location.pathname === '/signin') {
        return;
    }

    window.location.replace(signinUrl);
};

const handleExpiredSession = () => {
    if (sessionExpirationHandled) return;

    sessionExpirationHandled = true;

    clearStoredAuthData();
    saveSessionExpiredNotice(SESSION_EXPIRED_MESSAGE);

    store.dispatch({
        type: AUTH_SESSION_EXPIRED,
        payload: {
            message: SESSION_EXPIRED_MESSAGE,
        },
    });

    // Даём Redux завершить обновление, после чего полностью открываем экран входа.
    window.setTimeout(redirectToSignin, 0);
};

const rejectResponse = (error) => {
    const status = error?.response?.status || 0;
    const url = error?.config?.url || '';
    const method = error?.config?.method || '';
    const data = error?.response?.data || null;

    console.warn('[axios:error]', {
        method,
        url,
        status,
        data,
        message: error?.message,
    });

    /*
      Обрабатываем только реальное истечение JWT.
      Обычный 401 при неверном пароле не должен выкидывать пользователя
      повторно или создавать цикл на странице входа.
    */
    if (isJwtExpiredError(error) && !isAuthEntryRequest(url)) {
        handleExpiredSession();
    }

    return Promise.reject(error);
};

axiosInstance.interceptors.request.use((req) => {
    const token = getToken();

    req.headers = req.headers || {};

    // На вход и регистрацию старый JWT отправлять нельзя.
    if (token && !isAuthEntryRequest(req.url)) {
        req.headers.Authorization = `Bearer ${token}`;
    } else {
        delete req.headers.Authorization;
    }

    if (!req.headers.sitename && process.env.REACT_APP_SITE_NAME) {
        req.headers.sitename = process.env.REACT_APP_SITE_NAME;
    }

    return req;
});

axiosInstance.interceptors.response.use(
    (res) => res,
    rejectResponse
);

/*
  В проекте часть старых файлов может импортировать обычный axios напрямую.
  Этот перехватчик обеспечивает такое же поведение и для них.
*/
if (!axios.__adminSessionExpiryInterceptorInstalled) {
    axios.interceptors.response.use(
        (res) => res,
        rejectResponse
    );

    axios.__adminSessionExpiryInterceptorInstalled = true;
}

export default axiosInstance;
